import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { PrimaryTradeLicenseRequirement } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { TradeService } from 'src/app/services/trade.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-primary-trade-license-requirements-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './primary-trade-license-requirements-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrimaryTradeLicenseRequirementsGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private TradeService: TradeService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'PrimaryTradeLicenseRequirement';
    this.rowModelType = 'serverSide';
    this.suppressFieldDotNotation = false;

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.TradeService.getTradeRequirements(queryObject),
          this.TradeService.getTradeRequirementsCount(countQueryObject)
        ]).subscribe({
          next: ([Requirements, requirementsCount]: [
            PrimaryTradeLicenseRequirement[],
            number
          ]) => {
            const successObject: {
              rowData: PrimaryTradeLicenseRequirement[];
              rowCount: number;
            } = {
              rowData: Requirements,
              rowCount: requirementsCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
